{
  "about.blocks": "制限中のサーバー",
  "about.contact": "連絡先",
  "about.default_locale": "デフォルト",
  "about.disclaimer": "Mastodonは自由なオープンソースソフトウェアであり、Mastodon GmbHの商標です。",
  "about.domain_blocks.no_reason_available": "理由未記載",
  "about.domain_blocks.preamble": "Mastodonでは原則的にあらゆるサーバー同士で交流したり、互いの投稿を読んだりできますが、当サーバーでは例外的に次のような制限を設けています。",
  "about.domain_blocks.silenced.explanation": "このサーバーのプロフィールやコンテンツは、明示的に検索したり、フォローでオプトインしない限り、通常は表示されません。",
  "about.domain_blocks.silenced.title": "制限",
  "about.domain_blocks.suspended.explanation": "これらのサーバーからのデータは処理されず、保存や変換もされません。該当するユーザーとの交流もできません。",
  "about.domain_blocks.suspended.title": "停止中",
  "about.language_label": "言語",
  "about.not_available": "この情報はこのサーバーでは利用できません。",
  "about.powered_by": "{mastodon}による分散型ソーシャルメディア",
  "about.rules": "サーバーのルール",
  "account.account_note_header": "自分用メモ",
  "account.activity": "アクティビティ",
  "account.add_note": "個人的なメモを追加する",
  "account.add_or_remove_from_list": "リストから追加または外す",
  "account.badges.admin": "管理者",
  "account.badges.blocked": "ブロック中",
  "account.badges.bot": "Bot",
  "account.badges.domain_blocked": "ブロック中のドメイン",
  "account.badges.group": "Group",
  "account.badges.muted": "ミュート中",
  "account.badges.muted_until": "{until} までミュート中",
  "account.block": "@{name}さんをブロック",
  "account.block_domain": "{domain}全体をブロック",
  "account.block_short": "ブロック",
  "account.blocked": "ブロック済み",
  "account.cancel_follow_request": "フォローリクエストの取り消し",
  "account.copy": "プロフィールへのリンクをコピー",
  "account.direct": "@{name}さんに非公開でメンション",
  "account.disable_notifications": "@{name}さんの投稿時の通知を停止",
  "account.edit_note": "個人的なメモを編集する",
  "account.edit_profile": "プロフィール編集",
  "account.edit_profile_short": "編集",
  "account.enable_notifications": "@{name}さんの投稿時に通知",
  "account.endorse": "プロフィールで紹介する",
  "account.familiar_followers_many": "{name1}、{name2}、他{othersCount, plural, one {one other you know} other {# others you know}}人のユーザーにフォローされています",
  "account.familiar_followers_one": "{name1} さんがフォローしています",
  "account.familiar_followers_two": "{name1} さんと {name2} さんもフォローしています",
  "account.featured": "注目",
  "account.featured.accounts": "プロフィール",
  "account.featured.collections": "コレクション",
  "account.featured.new_collection": "新規のコレクション",
  "account.field_overflow": "すべて表示",
  "account.filters.all": "全てのアクティビティ",
  "account.filters.boosts_toggle": "ブーストを表示",
  "account.filters.posts_boosts": "投稿とブースト",
  "account.filters.posts_only": "投稿",
  "account.filters.posts_replies": "投稿と返信",
  "account.filters.replies_toggle": "返信を表示",
  "account.follow": "フォロー",
  "account.follow_back": "フォローバック",
  "account.follow_back_short": "フォローバック",
  "account.follow_request": "フォローリクエスト",
  "account.follow_request_cancel": "リクエストをキャンセル",
  "account.follow_request_cancel_short": "キャンセル",
  "account.follow_request_short": "リクエスト",
  "account.followers": "フォロワー",
  "account.followers.empty": "まだ誰もフォローしていません。",
  "account.followers_counter": "{count, plural, other {{counter} フォロワー}}",
  "account.followers_you_know_counter": "あなたと知り合いの{counter}人",
  "account.following": "フォロー中",
  "account.following_counter": "{count, plural, other {{counter} フォロー}}",
  "account.follows.empty": "まだ誰もフォローしていません。",
  "account.follows_you": "フォローされています",
  "account.go_to_profile": "プロフィールページへ",
  "account.hide_reblogs": "@{name}さんからのブーストを非表示",
  "account.in_memoriam": "故人を偲んで。",
  "account.join_modal.day": "日",
  "account.join_modal.me": "あなたが {server} に参加したのは",
  "account.join_modal.me_anniversary": "Fediversaryおめでとうございます！あなたが {server} に参加したのは",
  "account.join_modal.me_today": "今日は {server} での最初の日です！",
  "account.join_modal.other": "{name} が {server} に参加したのは",
  "account.join_modal.other_today": "今日は {name} の {server} での最初の日です！",
  "account.join_modal.share.celebrate": "お祝いの投稿を共有する",
  "account.join_modal.share.intro": "自己紹介の投稿を共有する",
  "account.join_modal.share.welcome": "歓迎の投稿を共有する",
  "account.join_modal.years": "{number, plural, one {年} other {年}}",
  "account.joined_short": "登録日",
  "account.languages": "購読言語の変更",
  "account.last_active": "最後の活動",
  "account.link_verified_on": "このリンクの所有権は{date}に確認されました",
  "account.locked_info": "このアカウントは承認制アカウントです。相手が承認するまでフォローは完了しません。",
  "account.media": "メディア",
  "account.mention": "@{name}さんにメンション",
  "account.menu.add_to_collection": "コレクションに追加…",
  "account.menu.add_to_list": "リストに追加する…",
  "account.menu.block": "アカウントをブロックする",
  "account.menu.block_domain": "{domain} をブロックする",
  "account.menu.copied": "アカウントへのリンクをクリップボードにコピーしました",
  "account.menu.copy": "リンクをコピーする",
  "account.menu.direct": "非公開でメンションする",
  "account.menu.hide_reblogs": "タイムラインでブーストを隠す",
  "account.menu.mention": "メンションする",
  "account.menu.mute": "アカウントをミュートする",
  "account.menu.note.description": "あなただけが見られます",
  "account.menu.open_original_page": "{domain} で表示する",
  "account.menu.remove_follower": "フォロワーを削除する",
  "account.menu.report": "アカウントを報告する",
  "account.menu.share": "共有…",
  "account.menu.show_reblogs": "タイムラインにブーストを表示する",
  "account.menu.unblock": "アカウントのブロックを解除する",
  "account.menu.unblock_domain": "{domain} のブロックを解除する",
  "account.menu.unmute": "アカウントのミュートを解除する",
  "account.moved_to": "{name}さんはこちらのアカウントに引っ越しました:",
  "account.mute": "@{name}さんをミュート",
  "account.mute_notifications_short": "通知をオフにする",
  "account.mute_short": "ミュート",
  "account.muted": "ミュート済み",
  "account.mutual": "相互フォロー中",
  "account.name.copy": "ハンドルをコピー",
  "account.name.help.domain": "{domain} はユーザーのプロフィールと投稿をホストするサーバーです。",
  "account.name.help.domain_self": "{domain} はあなたのプロフィールと投稿をホストするサーバーです。",
  "account.name.help.footer": "異なるメールプロバイダを利用してメールをやりとりできるように、他のMastodonサーバーやその他のFediverseアプリを利用している人たちと交流することができます。",
  "account.name.help.header": "ハンドルはメールアドレスのようなものです",
  "account.name.help.username": "{username} はこのアカウントのサーバーでのユーザー名です。別のサーバーの誰かが同じユーザー名を持っている可能性があります。",
  "account.name.help.username_self": "{username} はあなたのこのサーバーでのユーザー名です。別のサーバーの誰かが同じユーザー名を持っている可能性があります。",
  "account.name_info": "これは何？",
  "account.no_bio": "説明が提供されていません。",
  "account.node_modal.callout": "個人的なメモはあなただけが見られます。",
  "account.node_modal.edit_title": "個人的なメモを編集する",
  "account.node_modal.error_unknown": "メモを保存できませんでした",
  "account.node_modal.field_label": "個人的なメモ",
  "account.node_modal.save": "保存",
  "account.node_modal.title": "個人的なメモを追加する",
  "account.note.edit_button": "編集",
  "account.note.title": "個人的なメモ (あなただけが見られます)",
  "account.open_original_page": "元のページを開く",
  "account.pending": "承認待ち",
  "account.posts": "投稿",
  "account.remove_from_followers": "{name}さんをフォロワーから削除",
  "account.report": "@{name}さんを通報",
  "account.requested_follow": "{name}さんがあなたにフォローリクエストしました",
  "account.share": "@{name}さんのプロフィールを共有する",
  "account.show_reblogs": "@{name}さんからのブーストを表示",
  "account.statuses_counter": "{count, plural, other {{counter} 投稿}}",
  "account.timeline.pinned": "ピン済",
  "account.timeline.pinned.view_all": "ピン留め済みの投稿をすべて表示",
  "account.unblock": "@{name}さんのブロックを解除",
  "account.unblock_domain": "{domain}のブロックを解除",
  "account.unblock_domain_short": "ブロックを解除",
  "account.unblock_short": "ブロック解除",
  "account.unendorse": "プロフィールから外す",
  "account.unfollow": "フォロー解除",
  "account.unmute": "@{name}さんのミュートを解除",
  "account.unmute_notifications_short": "通知オフを解除",
  "account.unmute_short": "ミュート解除",
  "account_edit.advanced_settings.bot_hint": "このアカウントは主に自動的に動作していて監視されていない可能性があることを、他の人に示します",
  "account_edit.advanced_settings.bot_label": "自動アカウント",
  "account_edit.advanced_settings.title": "詳細設定",
  "account_edit.bio.add_label": "自己紹介を追加",
  "account_edit.bio.edit_label": "自己紹介を編集",
  "account_edit.bio.placeholder": "他の人があなたを認識できるよう簡単な自己紹介を追加しましょう。",
  "account_edit.bio.title": "自己紹介",
  "account_edit.bio_modal.add_title": "自己紹介を追加",
  "account_edit.bio_modal.edit_title": "自己紹介を編集",
  "account_edit.column_button": "完了",
  "account_edit.column_title": "プロフィールを編集",
  "admin.dashboard.daily_retention": "サインアップ後の日ごとのユーザー継続率",
  "admin.dashboard.monthly_retention": "サインアップ後の月ごとのユーザー継続率",
  "admin.dashboard.retention.average": "平均",
  "admin.dashboard.retention.cohort": "サインアップ月",
  "admin.dashboard.retention.cohort_size": "新しいユーザー",
  "admin.impact_report.instance_accounts": "プロフィール情報が削除されるアカウントの数",
  "admin.impact_report.instance_followers": "このサーバーのユーザーが失うフォロワー数",
  "admin.impact_report.instance_follows": "対象のサーバーのユーザーが失うフォロワー数",
  "admin.impact_report.title": "この操作による影響",
  "alert.rate_limited.message": "{retry_time, time, medium} 以降に再度実行してください。",
  "alert.rate_limited.title": "制限に達しました",
  "alert.unexpected.message": "不明なエラーが発生しました。",
  "alert.unexpected.title": "エラー！",
  "alt_text_badge.title": "代替テキスト",
  "alt_text_modal.add_alt_text": "代替テキストを追加",
  "alt_text_modal.add_text_from_image": "画像からテキストを追加",
  "alt_text_modal.cancel": "キャンセル",
  "alt_text_modal.change_thumbnail": "サムネイルを変更",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "耳の不自由な方のために説明してください…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "目が不自由な方のために説明してください…",
  "alt_text_modal.done": "完了",
  "announcement.announcement": "お知らせ",
  "annual_report.summary.copy_link": "リンクをコピー",
  "annual_report.summary.followers.new_followers": "{count, plural, other {新しいフォロワー}}",
  "annual_report.summary.highlighted_post.boost_count": "この投稿は {count, plural, other {# 回}}ブーストされました。",
  "annual_report.summary.highlighted_post.favourite_count": "この投稿は {count, plural, other {# 回}}お気に入りされました。",
  "annual_report.summary.highlighted_post.reply_count": "この投稿には {count, plural, other {# 回}}返信がありました。",
  "annual_report.summary.highlighted_post.title": "最も人気のある投稿",
  "annual_report.summary.most_used_app.most_used_app": "最も使用されているアプリ",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "最も使用されたハッシュタグ",
  "annual_report.summary.most_used_hashtag.used_count": "あなたはこのハッシュタグを {count, plural, other {# 件の投稿}}に含めました。",
  "annual_report.summary.new_posts.new_posts": "新しい投稿",
  "annual_report.summary.percentile.text": "<topLabel>{domain}で 上位</topLabel><percentage></percentage><bottomLabel>に入ります！</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "バー二ーには秘密にしておくよ。",
  "annual_report.summary.share_on_mastodon": "Mastodonで共有",
  "attachments_list.unprocessed": "(未処理)",
  "audio.hide": "音声を閉じる",
  "block_modal.remote_users_caveat": "このサーバーはあなたのブロックの意思を尊重するように {domain} へ通知します。しかし、サーバーによってはブロック機能の扱いが異なる場合もありえるため、相手のサーバー側で求める通りの処理が行われる確証はありません。また、公開投稿はユーザーがログアウト状態であれば閲覧できる可能性があります。",
  "block_modal.show_less": "表示を減らす",
  "block_modal.show_more": "続きを表示",
  "block_modal.they_will_know": "ブロックは相手からわかります。",
  "block_modal.title": "ユーザーをブロックしますか？",
  "boost_modal.combo": "次からは{combo}を押せばスキップできます",
  "boost_modal.reblog": "ブーストしますか？",
  "boost_modal.undo_reblog": "ブーストを解除しますか？",
  "bundle_column_error.copy_stacktrace": "エラーレポートをコピー",
  "bundle_column_error.error.body": "要求されたページをレンダリングできませんでした。コードのバグ、またはブラウザの互換性の問題が原因である可能性があります。",
  "bundle_column_error.error.title": "おっと！",
  "bundle_column_error.network.body": "このページを読み込もうとしたときにエラーが発生しました。インターネット接続またはこのサーバーの一時的な問題が発生した可能性があります。",
  "bundle_column_error.network.title": "ネットワークエラー",
  "bundle_column_error.retry": "再試行",
  "bundle_column_error.return": "ホームに戻る",
  "bundle_column_error.routing.body": "要求されたページは見つかりませんでした。アドレスバーのURLは正しいですか？",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "閉じる",
  "bundle_modal_error.message": "画面の読み込み中に問題が発生しました。",
  "bundle_modal_error.retry": "再試行",
  "closed_registrations.other_server_instructions": "Mastodonは分散型なので他のサーバーにアカウントを作ってもこのサーバーとやり取りできます。",
  "closed_registrations_modal.description": "現在{domain}でアカウント作成はできませんがMastodonは{domain}のアカウントでなくても利用できます。",
  "closed_registrations_modal.find_another_server": "別のサーバーを探す",
  "closed_registrations_modal.preamble": "Mastodonは分散型なのでどのサーバーでアカウントを作成してもこのサーバーのユーザーを誰でもフォローして交流することができます。また自分でホスティングすることもできます！",
  "closed_registrations_modal.title": "Mastodonでアカウントを作成",
  "collection.share_modal.share_via_post": "Mastodonに投稿",
  "collection.share_modal.share_via_system": "共有…",
  "collection.share_modal.title": "コレクションを共有",
  "collection.share_modal.title_new": "新しいコレクションを共有しよう！",
  "collections.accounts.empty_title": "このコレクションは空です",
  "collections.by_account": "{account_handle} による",
  "collections.collection_description": "詳細",
  "collections.collection_language": "言語",
  "collections.collection_name": "名前",
  "collections.collection_topic": "トピック",
  "collections.confirm_account_removal": "このコレクションからこのアカウントを削除してもよろしいですか？",
  "collections.content_warning": "閲覧注意",
  "collections.continue": "次に進む",
  "collections.create.accounts_title": "このコレクションで誰に注目しますか？",
  "collections.create.basic_details_title": "基本情報",
  "collections.create.steps": "ステップ {step}/{total}",
  "collections.create_collection": "コレクションを作成",
  "collections.delete_collection": "コレクションを削除",
  "collections.description_length_hint": "100 文字まで",
  "collections.detail.author_added_you_on_date": "{author} があなたを {date} に追加しました",
  "collections.detail.loading": "コレクションを読み込み中…",
  "collections.detail.share": "コレクションを共有",
  "collections.detail.you_are_in_this_collection": "あなたはこのコレクションで紹介されています",
  "collections.mark_as_sensitive": "閲覧注意としてマーク",
  "collections.mark_as_sensitive_hint": "コレクションの説明とアカウントを閲覧注意で隠します。コレクション名は表示されます。",
  "collections.name_length_hint": "40 文字まで",
  "collections.new_collection": "新規のコレクション",
  "collections.report_collection": "このコレクションを通報する",
  "collections.topic_hint": "ハッシュタグを追加して、このコレクションの主なトピックを知ってもらいましょう。",
  "collections.visibility_public": "公開",
  "collections.visibility_public_hint": "検索結果やその他おすすめに表示されて、見つけてもらうことができます。",
  "collections.visibility_title": "公開範囲",
  "collections.visibility_unlisted": "ひかえめな公開",
  "collections.visibility_unlisted_hint": "リンクを知っている人が見られます。検索結果やその他おすすめには表示さません。",
  "column.about": "概要",
  "column.blocks": "ブロックしたユーザー",
  "column.bookmarks": "ブックマーク",
  "column.community": "ローカルタイムライン",
  "column.create_list": "リストを作成",
  "column.direct": "非公開の返信",
  "column.directory": "ディレクトリ",
  "column.domain_blocks": "ブロックしたドメイン",
  "column.edit_list": "リストを編集",
  "column.favourites": "お気に入り",
  "column.firehose": "リアルタイムフィード",
  "column.firehose_local": "このサーバーのリアルタイムフィード",
  "column.firehose_singular": "リアルタイムフィード",
  "column.follow_requests": "フォローリクエスト",
  "column.home": "ホーム",
  "column.list_members": "リストのメンバーを管理",
  "column.lists": "リスト",
  "column.mutes": "ミュートしたユーザー",
  "column.notifications": "通知",
  "column.other_collections": "{name} によるコレクション",
  "column.pins": "固定された投稿",
  "column.public": "連合タイムライン",
  "column_back_button.label": "戻る",
  "column_header.hide_settings": "設定を隠す",
  "column_header.moveLeft_settings": "カラムを左に移動する",
  "column_header.moveRight_settings": "カラムを右に移動する",
  "column_header.pin": "ピン留めする",
  "column_header.show_settings": "設定を表示",
  "column_header.unpin": "ピン留めを外す",
  "column_search.cancel": "キャンセル",
  "combobox.loading": "読み込み中",
  "combobox.no_results_found": "検索結果はありません",
  "community.column_settings.local_only": "ローカルのみ表示",
  "community.column_settings.media_only": "メディアのみ表示",
  "community.column_settings.remote_only": "リモートのみ表示",
  "compose.language.change": "言語を変更",
  "compose.language.search": "言語を検索...",
  "compose.published.body": "投稿されました！",
  "compose.published.open": "開く",
  "compose.saved.body": "変更を保存しました。",
  "compose_form.direct_message_warning_learn_more": "もっと詳しく",
  "compose_form.encryption_warning": "Mastodonの投稿はエンドツーエンド暗号化に対応していません。安全に送受信されるべき情報をMastodonで共有しないでください。",
  "compose_form.favourite_tags": "お気に入りタグ",
  "compose_form.hashtag_warning": "この投稿は公開設定が未収載より狭いのでハッシュタグの一覧に表示されません。公開範囲が公開または未収載である投稿だけがハッシュタグで検索できます。",
  "compose_form.lock_disclaimer": "あなたのアカウントは{locked}になっていません。誰でもあなたをフォローすることができ、フォロワー限定の投稿を見ることができます。",
  "compose_form.lock_disclaimer.lock": "承認制",
  "compose_form.placeholder": "今なにしてる？",
  "compose_form.poll.duration": "アンケート期間",
  "compose_form.poll.multiple": "複数選択",
  "compose_form.poll.option_placeholder": "項目{number}",
  "compose_form.poll.single": "単一選択",
  "compose_form.poll.switch_to_multiple": "複数選択に変更",
  "compose_form.poll.switch_to_single": "単一選択に変更",
  "compose_form.poll.type": "スタイル",
  "compose_form.publish": "投稿",
  "compose_form.reply": "返信",
  "compose_form.save_changes": "更新",
  "compose_form.spoiler.marked": "本文は警告の後ろに隠されます",
  "compose_form.spoiler.unmarked": "本文は隠されていません",
  "compose_form.spoiler_placeholder": "閲覧注意 (オプション)",
  "confirmation_modal.cancel": "キャンセル",
  "confirmations.block.confirm": "ブロック",
  "confirmations.delete.confirm": "削除",
  "confirmations.delete.message": "本当に削除しますか？",
  "confirmations.delete.title": "投稿を削除しようとしています",
  "confirmations.delete_list.confirm": "削除",
  "confirmations.delete_list.message": "本当にこのリストを完全に削除しますか？",
  "confirmations.delete_list.title": "リストを削除しようとしています",
  "confirmations.discard_draft.confirm": "破棄して続ける",
  "confirmations.discard_draft.edit.cancel": "編集を再開",
  "confirmations.discard_draft.edit.message": "続行すると、現在編集している投稿に加えた変更は破棄されます。",
  "confirmations.discard_draft.edit.title": "投稿の変更を破棄しますか？",
  "confirmations.discard_draft.post.cancel": "下書きを再開",
  "confirmations.discard_draft.post.message": "続行すると、現在作成中の投稿が破棄されます。",
  "confirmations.discard_draft.post.title": "下書きを破棄しますか？",
  "confirmations.discard_edit_media.confirm": "破棄",
  "confirmations.discard_edit_media.message": "メディアの説明またはプレビューに保存されていない変更があります。それでも破棄しますか？",
  "confirmations.follow_to_list.confirm": "フォローしてリストに追加",
  "confirmations.follow_to_list.message": "リストに追加するには{name}さんをフォローしている必要があります。",
  "confirmations.follow_to_list.title": "ユーザーをフォローしますか？",
  "confirmations.logout.confirm": "ログアウト",
  "confirmations.logout.message": "本当にログアウトしますか？",
  "confirmations.logout.title": "ログアウトしようとしています",
  "confirmations.missing_alt_text.confirm": "代替テキストを追加",
  "confirmations.missing_alt_text.message": "あなたの投稿には代替テキストのないメディアが含まれています。説明文を追加することで、より多くの人がコンテンツにアクセスできるようになります。",
  "confirmations.missing_alt_text.secondary": "そのまま投稿する",
  "confirmations.missing_alt_text.title": "代替テキストを追加しますか？",
  "confirmations.mute.confirm": "ミュート",
  "confirmations.quiet_post_quote_info.dismiss": "次回からこのメッセージを表示しない",
  "confirmations.redraft.confirm": "削除して下書きに戻す",
  "confirmations.redraft.message": "投稿を削除して下書きに戻します。この投稿へのお気に入り登録やブーストは失われ、返信は孤立することになります。よろしいですか？",
  "confirmations.redraft.title": "投稿の削除と下書きの再作成",
  "confirmations.remove_from_followers.confirm": "フォロワーを削除",
  "confirmations.remove_from_followers.message": "{name}さんはあなたをフォローしなくなります。本当によろしいですか？",
  "confirmations.remove_from_followers.title": "フォロワーを削除しますか？",
  "confirmations.revoke_quote.confirm": "投稿を削除",
  "confirmations.revoke_quote.message": "この操作は元に戻せません。",
  "confirmations.revoke_quote.title": "投稿を削除しますか?",
  "confirmations.unblock.confirm": "ブロック解除",
  "confirmations.unblock.title": "@{name}さんのブロックを解除しますか？",
  "confirmations.unfollow.confirm": "フォロー解除",
  "confirmations.unfollow.title": "{name} さんのフォローを解除しますか？",
  "confirmations.withdraw_request.confirm": "リクエスト取り消し",
  "confirmations.withdraw_request.title": "{name} さんのフォローリクエストを取り消しますか？",
  "content_warning.hide": "内容を隠す",
  "content_warning.show": "承知して表示",
  "content_warning.show_more": "続きを表示",
  "conversation.delete": "会話を削除",
  "conversation.mark_as_read": "既読にする",
  "conversation.open": "会話を表示",
  "conversation.with": "{names}",
  "copy_icon_button.copied": "コピーしました",
  "copypaste.copied": "コピーしました",
  "copypaste.copy_to_clipboard": "クリップボードにコピー",
  "directory.federated": "既知の連合より",
  "directory.local": "{domain} のみ",
  "directory.new_arrivals": "新着順",
  "directory.recently_active": "最近の活動順",
  "disabled_account_banner.account_settings": "アカウント設定",
  "disabled_account_banner.text": "あなたのアカウント『{disabledAccount}』は現在無効になっています。",
  "dismissable_banner.community_timeline": "これらは{domain}がホストしている人たちの最新の公開投稿です。",
  "dismissable_banner.dismiss": "閉じる",
  "dismissable_banner.public_timeline": "{domain}のユーザーがフォローしているFediverseユーザーによる最近の公開投稿です。",
  "domain_block_modal.block": "サーバーをブロック",
  "domain_block_modal.block_account_instead": "@{name} さんのみをブロック",
  "domain_block_modal.they_can_interact_with_old_posts": "あなたの今までの投稿は、引き続きこのサーバーのユーザーが閲覧できます。",
  "domain_block_modal.they_cant_follow": "このサーバーのユーザーはあなたをフォローできなくなります。",
  "domain_block_modal.they_wont_know": "ドメインブロックは相手からはわかりません。",
  "domain_block_modal.title": "ドメインをブロックしますか？",
  "domain_block_modal.you_will_lose_num_followers": "「{followingCount, plural, other {{followingCountDisplay}フォロー}}」、「{followersCount, plural, other {{followersCountDisplay}フォロワー}}」を失うことになります。",
  "domain_block_modal.you_will_lose_relationships": "このサーバーにいるすべてのフォローとフォロワーを失うことになります。",
  "domain_block_modal.you_wont_see_posts": "このサーバーのユーザーからの投稿や通知が閲覧できなくなります。",
  "embed.instructions": "下記のコードをコピーしてウェブサイトに埋め込みます。",
  "embed.preview": "表示例:",
  "emoji_button.activity": "活動",
  "emoji_button.clear": "クリア",
  "emoji_button.custom": "カスタム絵文字",
  "emoji_button.flags": "国旗",
  "emoji_button.food": "食べ物",
  "emoji_button.label": "絵文字を追加",
  "emoji_button.nature": "自然",
  "emoji_button.not_found": "絵文字がなーい！！ (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "物",
  "emoji_button.people": "人々",
  "emoji_button.recent": "よく使う絵文字",
  "emoji_button.search": "検索...",
  "emoji_button.search_results": "検索結果",
  "emoji_button.symbols": "記号",
  "emoji_button.travel": "旅行と場所",
  "empty_column.account_hides_collections": "このユーザーはこの情報を開示しないことにしています。",
  "empty_column.account_suspended": "アカウントは停止されています",
  "empty_column.account_timeline": "投稿がありません！",
  "empty_column.account_unavailable": "プロフィールは利用できません",
  "empty_column.blocks": "まだ誰もブロックしていません。",
  "empty_column.bookmarked_statuses": "まだ何もブックマーク登録していません。ブックマーク登録するとここに表示されます。",
  "empty_column.community": "ローカルタイムラインはまだ使われていません。何か書いてみましょう！",
  "empty_column.direct": "非公開の返信はまだありません。非公開でやりとりをするとここに表示されます。",
  "empty_column.disabled_feed": "このフィードはサーバー管理者によって無効にされています。",
  "empty_column.domain_blocks": "ブロックしているドメインはありません。",
  "empty_column.explore_statuses": "まだ何もありません。後で確認してください。",
  "empty_column.favourited_statuses": "お気に入りの投稿はまだありません。お気に入りに登録すると、ここに表示されます。",
  "empty_column.favourites": "まだ誰もこの投稿をお気に入りに登録していません。お気に入りに登録されると、ここに表示されます。",
  "empty_column.follow_requests": "まだフォローリクエストを受けていません。フォローリクエストを受けるとここに表示されます。",
  "empty_column.followed_tags": "まだハッシュタグをフォローしていません。フォローするとここに表示されます。",
  "empty_column.hashtag": "このハッシュタグはまだ使われていません。",
  "empty_column.home": "ホームタイムラインはまだ空っぽです。だれかをフォローして埋めてみましょう。",
  "empty_column.list": "このリストにはまだなにもありません。このリストのメンバーが新しい投稿をするとここに表示されます。",
  "empty_column.mutes": "まだ誰もミュートしていません。",
  "empty_column.notification_requests": "ここに表示するものはありません。新しい通知を受け取ったとき、フィルタリング設定で通知がブロックされたアカウントがある場合はここに表示されます。",
  "empty_column.notifications": "まだ通知がありません。他の人とふれ合って会話を始めましょう。",
  "empty_column.public": "ここにはまだ何もありません！ 公開で何かを投稿したり、他のサーバーのユーザーをフォローしたりしていっぱいにしましょう",
  "error.unexpected_crash.explanation": "不具合かブラウザの互換性問題のため、このページを正しく表示できませんでした。",
  "error.unexpected_crash.explanation_addons": "このページは正しく表示できませんでした。このエラーはブラウザのアドオンや自動翻訳ツールによって引き起こされることがあります。",
  "error.unexpected_crash.next_steps": "ページの再読み込みをお試しください。それでも解決しない場合、別のブラウザかアプリを使えば使用できることがあります。",
  "error.unexpected_crash.next_steps_addons": "それらを無効化してからリロードをお試しください。それでも解決しない場合、他のブラウザやアプリで Mastodon をお試しください。",
  "errors.unexpected_crash.copy_stacktrace": "スタックトレースをクリップボードにコピー",
  "errors.unexpected_crash.report_issue": "問題を報告",
  "explore.suggested_follows": "ユーザー",
  "explore.title": "トレンド",
  "explore.trending_links": "ニュース",
  "explore.trending_statuses": "投稿",
  "explore.trending_tags": "ハッシュタグ",
  "featured_carousel.header": "{count, plural, other {ピン留めされた投稿}}",
  "filter_modal.added.context_mismatch_explanation": "このフィルターカテゴリーはあなたがアクセスした投稿のコンテキストには適用されません。この投稿のコンテキストでもフィルターを適用するにはフィルターを編集する必要があります。",
  "filter_modal.added.context_mismatch_title": "コンテキストが一致しません！",
  "filter_modal.added.expired_explanation": "このフィルターカテゴリーは有効期限が切れています。適用するには有効期限を更新してください。",
  "filter_modal.added.expired_title": "フィルターの有効期限が切れています！",
  "filter_modal.added.review_and_configure": "このフィルターカテゴリーを確認して設定するには、{settings_link}に移動します。",
  "filter_modal.added.review_and_configure_title": "フィルター設定",
  "filter_modal.added.settings_link": "設定",
  "filter_modal.added.short_explanation": "この投稿はフィルターカテゴリー『{title}』に追加されました。",
  "filter_modal.added.title": "フィルターを追加しました!",
  "filter_modal.select_filter.context_mismatch": "このコンテキストには当てはまりません",
  "filter_modal.select_filter.expired": "期限切れ",
  "filter_modal.select_filter.prompt_new": "新しいカテゴリー: {name}",
  "filter_modal.select_filter.search": "検索または新規作成",
  "filter_modal.select_filter.subtitle": "既存のカテゴリーを使用するか新規作成します",
  "filter_modal.select_filter.title": "この投稿をフィルターする",
  "filter_modal.title.status": "投稿をフィルターする",
  "filter_warning.matches_filter": "フィルター「<span>{title}</span>」に一致する投稿",
  "filtered_notifications_banner.pending_requests": "{count, plural,  =0 {すべて完了しました} other {#人の通知がブロックされています}}",
  "filtered_notifications_banner.title": "保留中の通知",
  "firehose.all": "すべて",
  "firehose.local": "このサーバー",
  "firehose.remote": "ほかのサーバー",
  "follow_request.authorize": "許可",
  "follow_request.reject": "拒否",
  "follow_requests.unlocked_explanation": "あなたのアカウントは承認制ではありませんが、{domain}のスタッフはこれらのアカウントからのフォローリクエストの確認が必要であると判断しました。",
  "follow_suggestions.curated_suggestion": "サーバースタッフ公認",
  "follow_suggestions.dismiss": "今後表示しない",
  "follow_suggestions.featured_longer": "{domain} スタッフ公認",
  "follow_suggestions.friends_of_friends_longer": "フォロー中のユーザーに人気",
  "follow_suggestions.hints.featured": "{domain} の運営スタッフが選んだアカウントです。",
  "follow_suggestions.hints.friends_of_friends": "フォロー中のユーザーのあいだで人気のアカウントです。",
  "follow_suggestions.hints.most_followed": "{domain} でもっともフォローされているアカウントのひとつです。",
  "follow_suggestions.hints.most_interactions": "{domain} でいま大きな注目を集めています。",
  "follow_suggestions.hints.similar_to_recently_followed": "最近フォローしたユーザーに似ているアカウントです。",
  "follow_suggestions.personalized_suggestion": "フォローに基づく提案",
  "follow_suggestions.popular_suggestion": "人気のアカウント",
  "follow_suggestions.popular_suggestion_longer": "{domain} で人気",
  "follow_suggestions.similar_to_recently_followed_longer": "最近フォローしたユーザーと似ているアカウント",
  "follow_suggestions.view_all": "すべて表示",
  "follow_suggestions.who_to_follow": "フォローを増やしてみませんか？",
  "followed_tags": "フォロー中のハッシュタグ",
  "footer.about": "概要",
  "footer.about_this_server": "概要",
  "footer.directory": "ディレクトリ",
  "footer.get_app": "アプリを入手",
  "footer.keyboard_shortcuts": "キーボードショートカット",
  "footer.privacy_policy": "プライバシーポリシー",
  "footer.source_code": "ソースコードを表示",
  "footer.status": "ステータス",
  "footer.terms_of_service": "サービス利用規約",
  "form_field.optional": "(省略可能)",
  "getting_started.heading": "スタート",
  "hashtag.admin_moderation": "#{name}のモデレーション画面を開く",
  "hashtag.browse": "#{hashtag}が付いた投稿を閲覧する",
  "hashtag.browse_from_account": "#{hashtag}が付いた{name}の投稿を閲覧する",
  "hashtag.column_header.tag_mode.all": "と{additional}",
  "hashtag.column_header.tag_mode.any": "か{additional}",
  "hashtag.column_header.tag_mode.none": "({additional} を除く)",
  "hashtag.column_settings.select.no_options_message": "提案はありません",
  "hashtag.column_settings.select.placeholder": "ハッシュタグを入力してください…",
  "hashtag.column_settings.tag_mode.all": "すべてを含む",
  "hashtag.column_settings.tag_mode.any": "いずれかを含む",
  "hashtag.column_settings.tag_mode.none": "これらを除く",
  "hashtag.column_settings.tag_toggle": "このカラムに追加のタグを含める",
  "hashtag.counter_by_accounts": "{count, plural, other {{counter}人投稿}}",
  "hashtag.counter_by_uses": "{count, plural, other {{counter}件}}",
  "hashtag.counter_by_uses_today": "本日{count, plural, other {#件}}",
  "hashtag.feature": "プロフィールで紹介する",
  "hashtag.follow": "ハッシュタグをフォローする",
  "hashtag.mute": "#{hashtag}をミュート",
  "hashtag.unfeature": "プロフィールから外す",
  "hashtag.unfollow": "ハッシュタグのフォローを解除",
  "hashtags.and_other": "ほか{count, plural, other {#個}}",
  "hints.profiles.followers_may_be_missing": "フォロワーの一覧は不正確な場合があります。",
  "hints.profiles.follows_may_be_missing": "フォローの一覧は不正確な場合があります。",
  "hints.profiles.posts_may_be_missing": "すべての投稿を表示できていない場合があります。",
  "hints.profiles.see_more_followers": "{domain} で正確な情報を見る",
  "hints.profiles.see_more_follows": "{domain} で正確な情報を見る",
  "hints.profiles.see_more_posts": "{domain} でその他の投稿を見る",
  "home.column_settings.show_quotes": "引用を表示",
  "home.column_settings.show_reblogs": "ブースト表示",
  "home.column_settings.show_replies": "返信表示",
  "home.hide_announcements": "お知らせを隠す",
  "home.pending_critical_update.body": "速やかにMastodonサーバーをアップデートしてください。",
  "home.pending_critical_update.link": "詳細",
  "home.pending_critical_update.title": "緊急のセキュリティアップデートがあります",
  "home.show_announcements": "お知らせを表示",
  "ignore_notifications_modal.disclaimer": "通知が無視されていることは通知の送信元の相手には伝わりません。通知が破棄されるのみで、投稿や返信の送信を止めさせる効果はありません。",
  "ignore_notifications_modal.filter_instead": "「保留」に設定",
  "ignore_notifications_modal.filter_to_act_users": "保留された通知は「受け入れ」「無視」を選択できます。当該ユーザーの通報も可能です",
  "ignore_notifications_modal.filter_to_avoid_confusion": "通知の破棄による意図しない混乱を避けるためにも、「保留」設定の使用を検討してください",
  "ignore_notifications_modal.filter_to_review_separately": "「保留」設定を使用することで、保留された通知を個別に確認できます",
  "ignore_notifications_modal.ignore": "「無視」に設定",
  "ignore_notifications_modal.limited_accounts_title": "本当に「モデレーションされたアカウントからの通知」を無視するようにしますか？",
  "ignore_notifications_modal.new_accounts_title": "本当に「新しいアカウントからの通知」を無視するようにしますか？",
  "ignore_notifications_modal.not_followers_title": "本当に「フォローされていないアカウントからの通知」を無視するようにしますか？",
  "ignore_notifications_modal.not_following_title": "本当に「フォローしていないアカウントからの通知」を無視するようにしますか？",
  "ignore_notifications_modal.private_mentions_title": "本当に「外部からの非公開の返信」を無視するようにしますか？",
  "info_button.label": "ヘルプ",
  "info_button.what_is_alt_text": "<h1>代替テキストとは何ですか？</h1> <p>代替テキストは、視覚障害、低速ネットワーク接続の人や追加コンテンツを求める人に役立つ画像説明です。</p> <p>明確、簡潔、客観的に記述することでアクセシビリティが向上し、より多くの人に理解されるようになります。</p> <ul> <li>要点をとらえる</li> <li>画像内のテキストを要約する</li> <li>平易な文章で説明する</li> <li>情報の重複を避ける</li> <li>複雑な内容 (図や地図など) では傾向やポイントを見つける</li> </ul>",
  "interaction_modal.go": "サーバーに移動",
  "interaction_modal.no_account_yet": "アカウントを持っていない場合は:",
  "interaction_modal.on_another_server": "別のサーバー",
  "interaction_modal.on_this_server": "このサーバー",
  "interaction_modal.username_prompt": "例: {example}",
  "intervals.full.days": "{number}日",
  "intervals.full.hours": "{number}時間",
  "intervals.full.minutes": "{number}分",
  "keyboard_shortcuts.back": "戻る",
  "keyboard_shortcuts.blocked": "ブロックしたユーザーのリストを開く",
  "keyboard_shortcuts.boost": "ブースト",
  "keyboard_shortcuts.column": "左からn番目のカラムの最新に移動",
  "keyboard_shortcuts.compose": "投稿の入力欄に移動",
  "keyboard_shortcuts.description": "説明",
  "keyboard_shortcuts.down": "カラム内一つ下に移動",
  "keyboard_shortcuts.enter": "投稿の詳細を表示",
  "keyboard_shortcuts.favourite": "お気に入りの投稿",
  "keyboard_shortcuts.favourites": "お気に入りリストを開く",
  "keyboard_shortcuts.federated": "連合タイムラインを開く",
  "keyboard_shortcuts.heading": "キーボードショートカット",
  "keyboard_shortcuts.home": "ホームタイムラインを開く",
  "keyboard_shortcuts.hotkey": "ホットキー",
  "keyboard_shortcuts.legend": "この一覧を表示",
  "keyboard_shortcuts.load_more": "「もっと見る」ボタンに移動",
  "keyboard_shortcuts.local": "ローカルタイムラインを開く",
  "keyboard_shortcuts.mention": "メンション",
  "keyboard_shortcuts.muted": "ミュートしたユーザーのリストを開く",
  "keyboard_shortcuts.my_profile": "自分のプロフィールを開く",
  "keyboard_shortcuts.notifications": "通知カラムを開く",
  "keyboard_shortcuts.open_media": "メディアを開く",
  "keyboard_shortcuts.pinned": "固定した投稿のリストを開く",
  "keyboard_shortcuts.profile": "プロフィールを開く",
  "keyboard_shortcuts.quote": "引用投稿",
  "keyboard_shortcuts.reply": "返信",
  "keyboard_shortcuts.requests": "フォローリクエストのリストを開く",
  "keyboard_shortcuts.search": "検索欄に移動",
  "keyboard_shortcuts.spoilers": "閲覧注意を表示する/隠す",
  "keyboard_shortcuts.start": "\"スタート\" カラムを開く",
  "keyboard_shortcuts.toggle_hidden": "CWで隠れた文を見る/隠す",
  "keyboard_shortcuts.toggle_sensitivity": "非表示のメディアを見る/隠す",
  "keyboard_shortcuts.toot": "新規投稿",
  "keyboard_shortcuts.unfocus": "投稿の入力欄・検索欄から離れる",
  "keyboard_shortcuts.up": "カラム内一つ上に移動",
  "learn_more_link.got_it": "了解",
  "learn_more_link.learn_more": "もっと見る",
  "lightbox.close": "閉じる",
  "lightbox.next": "次",
  "lightbox.previous": "前",
  "lightbox.zoom_in": "実際のサイズにする",
  "lightbox.zoom_out": "表示範囲に合わせる",
  "limited_account_hint.action": "構わず表示する",
  "link_preview.author": "{name}",
  "link_preview.more_from_author": "{name}さんの投稿をもっと読む",
  "link_preview.shares": "{count, plural, other {{counter}件の投稿}}",
  "lists.add_member": "追加",
  "lists.add_to_list": "リストに追加",
  "lists.add_to_lists": "{name}をリストに追加",
  "lists.create": "作成",
  "lists.create_a_list_to_organize": "リストを作成するとホームタイムラインを見やすく整理できます",
  "lists.create_list": "リストを作成",
  "lists.delete": "リストを削除",
  "lists.done": "完了",
  "lists.edit": "リストを編集",
  "lists.exclusive": "メンバーをホームに表示しない",
  "lists.exclusive_hint": "リストにあるユーザーをホームタイムラインに表示しません。二重に表示させたくない場合に使用できます。",
  "lists.find_users_to_add": "追加するユーザーを探しましょう",
  "lists.list_members_count": "{count, plural, other{#人のメンバー}}",
  "lists.list_name": "リスト名",
  "lists.new_list_name": "新しいリスト名",
  "lists.no_lists_yet": "まだリストがありません。",
  "lists.no_members_yet": "まだメンバーがいません。",
  "lists.no_results_found": "該当するものが見つかりませんでした。",
  "lists.remove_member": "削除",
  "lists.replies_policy.followed": "フォロー中のユーザー全員",
  "lists.replies_policy.list": "リストのメンバー",
  "lists.replies_policy.none": "表示しない",
  "lists.save": "保存",
  "lists.search": "検索",
  "lists.show_replies_to": "メンバーの返信投稿の表示基準",
  "load_pending": "{count}件の新着",
  "loading_indicator.label": "読み込み中…",
  "media_gallery.hide": "隠す",
  "moved_to_account_banner.text": "あなたのアカウント『{disabledAccount}』は『{movedToAccount}』に移動したため現在無効になっています。",
  "mute_modal.hide_from_notifications": "通知をオフにする",
  "mute_modal.hide_options": "オプションを閉じる",
  "mute_modal.indefinite": "無期限",
  "mute_modal.show_options": "オプションを表示",
  "mute_modal.they_can_mention_and_follow": "相手はあなたへの返信やフォローができますが、あなたには見えません。",
  "mute_modal.they_wont_know": "ミュートは相手からはわかりません。",
  "mute_modal.title": "ユーザーをミュートしますか？",
  "mute_modal.you_wont_see_mentions": "宛先に相手が入っている投稿も閲覧できなくなります。",
  "mute_modal.you_wont_see_posts": "相手はあなたの投稿を今までどおり閲覧できますが、あなたは相手の投稿を閲覧できなくなります。",
  "navigation_bar.about": "概要",
  "navigation_bar.account_settings": "パスワードとセキュリティ",
  "navigation_bar.administration": "管理",
  "navigation_bar.advanced_interface": "上級者向けUIに戻る",
  "navigation_bar.automated_deletion": "投稿の自動削除",
  "navigation_bar.blocks": "ブロックしたユーザー",
  "navigation_bar.bookmarks": "ブックマーク",
  "navigation_bar.collections": "コレクション",
  "navigation_bar.direct": "非公開の返信",
  "navigation_bar.domain_blocks": "ブロックしたドメイン",
  "navigation_bar.favourites": "お気に入り",
  "navigation_bar.faq": "アイマストドンかんたんガイド",
  "navigation_bar.filters": "フィルター設定",
  "navigation_bar.follow_requests": "フォローリクエスト",
  "navigation_bar.followed_tags": "フォロー中のハッシュタグ",
  "navigation_bar.follows_and_followers": "フォロー・フォロワー",
  "navigation_bar.import_export": "インポートとエクスポート",
  "navigation_bar.lists": "リスト",
  "navigation_bar.live_feed_local": "リアルタイムフィード (このサーバー)",
  "navigation_bar.live_feed_public": "リアルタイムフィード (すべて)",
  "navigation_bar.logout": "ログアウト",
  "navigation_bar.moderation": "モデレーション",
  "navigation_bar.more": "もっと見る",
  "navigation_bar.mutes": "ミュートしたユーザー",
  "navigation_bar.opened_in_classic_interface": "投稿やプロフィールを直接開いた場合は一時的に標準UIで表示されます。",
  "navigation_bar.preferences": "ユーザー設定",
  "navigation_bar.privacy_and_reach": "プライバシーとつながりやすさ",
  "navigation_bar.search": "検索",
  "navigation_bar.search_trends": "検索 / トレンド",
  "navigation_panel.collapse_followed_tags": "フォロー中のハッシュタグメニューを閉じる",
  "navigation_panel.collapse_lists": "リストメニューを閉じる",
  "navigation_panel.expand_followed_tags": "フォロー中のハッシュタグメニューを展開",
  "navigation_panel.expand_lists": "リストメニューを展開",
  "not_signed_in_indicator.not_signed_in": "この機能を使うにはログインする必要があります。",
  "notification.admin.report": "{name}さんが{target}さんを通報しました",
  "notification.admin.report_account": "{name}さんが{target}さんの投稿{count, plural, other {#件}}を「{category}」として通報しました",
  "notification.admin.report_account_other": "{name}さんが{target}さんの投稿{count, plural, other {#件}}を通報しました",
  "notification.admin.report_statuses": "{name}さんが{target}さんを「{category}」として通報しました",
  "notification.admin.report_statuses_other": "{name}さんが{target}さんを通報しました",
  "notification.admin.sign_up": "{name}さんがサインアップしました",
  "notification.admin.sign_up.name_and_others": "{name}さんとほか{count, plural, other {#人}}がサインアップしました",
  "notification.annual_report.message": "「あなたの{year}年の#Wrapstodonが待っています！Mastodonであなたの年のハイライトや思い出の瞬間を公開しましょう！」と訳せます。",
  "notification.annual_report.view": "#Wrapstodon を表示",
  "notification.favourite": "{name}さんがお気に入りしました",
  "notification.favourite.name_and_others_with_link": "{name}さんと<a>ほか{count, plural, other {#人}}</a>がお気に入りしました",
  "notification.favourite_pm": "{name} があなたのプライベートメンションをお気に入りにしました",
  "notification.favourite_pm.name_and_others_with_link": "{name} と <a>{count, plural, other {#人}}</a> があなたのプライベートメンションをお気に入りにしました",
  "notification.follow": "{name}さんにフォローされました",
  "notification.follow.name_and_others": "{name}さんと<a>ほか{count, plural, other {#人}}</a>にフォローされました",
  "notification.follow_request": "{name}さんがあなたにフォローリクエストしました",
  "notification.follow_request.name_and_others": "{name}さんとほか{count, plural, other {#人}}があなたにフォローリクエストしました",
  "notification.label.mention": "メンション",
  "notification.label.private_mention": "非公開の返信 (メンション)",
  "notification.label.private_reply": "非公開の返信",
  "notification.label.quote": "{name}さんがあなたの投稿を引用しました",
  "notification.label.reply": "返信",
  "notification.mention": "メンション",
  "notification.mentioned_you": "{name} さんがあなたに返信しました",
  "notification.moderation-warning.learn_more": "さらに詳しく",
  "notification.moderation_warning": "管理者から警告が来ています",
  "notification.moderation_warning.action_delete_statuses": "あなたによるいくつかの投稿が削除されました。",
  "notification.moderation_warning.action_disable": "あなたのアカウントは無効になりました。",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "あなたの投稿のいくつかは閲覧注意として判定されています。",
  "notification.moderation_warning.action_none": "あなたのアカウントは管理者からの警告を受けています。",
  "notification.moderation_warning.action_sensitive": "あなたの投稿はこれから閲覧注意としてマークされます。",
  "notification.moderation_warning.action_silence": "あなたのアカウントは制限されています。",
  "notification.moderation_warning.action_suspend": "あなたのアカウントは停止されました。",
  "notification.own_poll": "アンケートが終了しました",
  "notification.poll": "投票したアンケートが終了しました",
  "notification.quoted_update": "あなたが引用した投稿を {name} が編集しました",
  "notification.reblog": "{name}さんがあなたの投稿をブーストしました",
  "notification.reblog.name_and_others_with_link": "{name}さんと<a>ほか{count, plural, other {#人}}</a>がブーストしました",
  "notification.relationships_severance_event": "{name} との関係が失われました",
  "notification.relationships_severance_event.account_suspension": "{from} の管理者が {target} さんを停止したため、今後このユーザーとの交流や新しい投稿の受け取りができなくなりました。",
  "notification.relationships_severance_event.domain_block": "{from} の管理者が {target} をブロックしました。これにより{followersCount}フォロワーと{followingCount, plural, other {#フォロー}}が失われました。",
  "notification.relationships_severance_event.learn_more": "詳細を確認",
  "notification.relationships_severance_event.user_domain_block": "{target} のブロックにより{followersCount}フォロワーと{followingCount, plural, other {#フォロー}}が解除されました。",
  "notification.status": "{name}さんが投稿しました",
  "notification.update": "{name}さんが投稿を編集しました",
  "notification_requests.accept": "受け入れる",
  "notification_requests.accept_multiple": "{count, plural, other {選択中の#件を受け入れる}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, other {#件のアカウントを受け入れる}}",
  "notification_requests.confirm_accept_multiple.message": "{count, plural, other {#件のアカウント}}に対して今後通知を受け入れるようにします。よろしいですか？",
  "notification_requests.confirm_accept_multiple.title": "保留中のアカウントの受け入れ",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, other {#件のアカウントを無視する}}",
  "notification_requests.confirm_dismiss_multiple.message": "{count, plural, other {#件のアカウント}}からの通知を今後無視するようにします。一度この操作を行った{count, plural, other {アカウント}}とふたたび出会うことは容易ではありません。よろしいですか？",
  "notification_requests.confirm_dismiss_multiple.title": "保留中のアカウントを無視しようとしています",
  "notification_requests.dismiss": "無視",
  "notification_requests.dismiss_multiple": "{count, plural, other {選択中の#件を無視する}}",
  "notification_requests.edit_selection": "選択",
  "notification_requests.exit_selection": "選択の終了",
  "notification_requests.explainer_for_limited_account": "このアカウントはモデレーターにより制限が課されているため、このアカウントによる通知は保留されています",
  "notification_requests.explainer_for_limited_remote_account": "このアカウントが所属するサーバーはモデレーターにより制限が課されているため、このアカウントによる通知は保留されています",
  "notification_requests.maximize": "最大化",
  "notification_requests.minimize_banner": "「保留中の通知」のバナーを最小化する",
  "notification_requests.notifications_from": "{name}からの通知",
  "notification_requests.title": "保留中の通知",
  "notification_requests.view": "通知を見る",
  "notifications.clear": "通知を消去",
  "notifications.clear_confirmation": "本当に通知を消去しますか？",
  "notifications.clear_title": "通知を消去しようとしています",
  "notifications.column_settings.admin.report": "新しい通報",
  "notifications.column_settings.admin.sign_up": "新規登録",
  "notifications.column_settings.alert": "デスクトップ通知",
  "notifications.column_settings.favourite": "お気に入り",
  "notifications.column_settings.filter_bar.advanced": "すべてのカテゴリを表示",
  "notifications.column_settings.filter_bar.category": "クイックフィルターバー",
  "notifications.column_settings.follow": "新しいフォロワー",
  "notifications.column_settings.follow_request": "新しいフォローリクエスト",
  "notifications.column_settings.group": "グループ",
  "notifications.column_settings.mention": "返信",
  "notifications.column_settings.poll": "アンケート結果",
  "notifications.column_settings.push": "プッシュ通知",
  "notifications.column_settings.quote": "引用",
  "notifications.column_settings.reblog": "ブースト",
  "notifications.column_settings.show": "カラムに表示",
  "notifications.column_settings.sound": "通知音を再生",
  "notifications.column_settings.status": "新しい投稿",
  "notifications.column_settings.unread_notifications.category": "未読の通知",
  "notifications.column_settings.unread_notifications.highlight": "未読の通知を強調表示",
  "notifications.column_settings.update": "編集",
  "notifications.filter.all": "すべて",
  "notifications.filter.boosts": "ブースト",
  "notifications.filter.favourites": "お気に入り",
  "notifications.filter.follows": "フォロー",
  "notifications.filter.mentions": "返信",
  "notifications.filter.polls": "アンケート結果",
  "notifications.filter.statuses": "フォローしている人の新着情報",
  "notifications.grant_permission": "権限の付与",
  "notifications.group": "{count}件の通知",
  "notifications.mark_as_read": "すべて既読にする",
  "notifications.permission_denied": "ブラウザの通知が拒否されているためデスクトップ通知は利用できません",
  "notifications.permission_denied_alert": "ブラウザの通知が拒否されているためデスクトップ通知を有効にできません",
  "notifications.permission_required": "必要な権限が付与されていないため、デスクトップ通知は利用できません。",
  "notifications.policy.accept": "受け入れ",
  "notifications.policy.accept_hint": "通知を表示します",
  "notifications.policy.drop": "無視",
  "notifications.policy.drop_hint": "通知を破棄します。再表示はできません。",
  "notifications.policy.filter": "保留",
  "notifications.policy.filter_hint": "「保留中の通知」に止め置きます",
  "notifications.policy.filter_limited_accounts_hint": "モデレーターにより制限されたアカウントから送られる通知が対象です",
  "notifications.policy.filter_limited_accounts_title": "モデレーションされたアカウントからの通知",
  "notifications.policy.filter_new_accounts.hint": "作成から{days, plural, other {#日}}以内のアカウントが対象です",
  "notifications.policy.filter_new_accounts_title": "新しいアカウントからの通知",
  "notifications.policy.filter_not_followers_hint": "フォローされていても、フォローから{days, plural, other {#日}}経っていない場合は対象になります",
  "notifications.policy.filter_not_followers_title": "フォローされていないアカウントからの通知",
  "notifications.policy.filter_not_following_hint": "手動で通知を受け入れたアカウントは対象外です",
  "notifications.policy.filter_not_following_title": "フォローしていないアカウントからの通知",
  "notifications.policy.filter_private_mentions_hint": "メンションした相手からの返信、およびフォローしているアカウントからの返信は対象外です",
  "notifications.policy.filter_private_mentions_title": "外部からの非公開の返信",
  "notifications.policy.title": "通知のフィルタリング",
  "notifications_permission_banner.enable": "デスクトップ通知を有効にする",
  "notifications_permission_banner.how_to_control": "Mastodonを閉じている間でも通知を受信するにはデスクトップ通知を有効にしてください。有効にすると上の {icon} ボタンから通知の内容を細かくカスタマイズできます。",
  "notifications_permission_banner.title": "お見逃しなく",
  "onboarding.follows.back": "戻る",
  "onboarding.follows.empty": "表示できる結果はありません。検索やエクスプローラーを使ったり、ほかのアカウントをフォローしたり、後でもう一度試しください。",
  "onboarding.follows.search": "検索",
  "onboarding.follows.title": "最初にフォローする人を選ぶ",
  "onboarding.profile.discoverable": "自分のプロフィールが見つけられるようにする",
  "onboarding.profile.discoverable_hint": "Mastodonの「見つける」機能にオプトインすると、あなたの投稿が検索結果やトレンドに表示されることがあります。また、あなたに似た関心を持つ人にプロフィールがおすすめされることがあります。",
  "onboarding.profile.display_name": "表示名",
  "onboarding.profile.display_name_hint": "フルネーム、あるいは面白い名前など",
  "onboarding.profile.note": "自己紹介",
  "onboarding.profile.note_hint": "ほかのユーザーへのメンション (@mention) や、 #ハッシュタグ が使用できます",
  "onboarding.profile.title": "プロフィールの設定",
  "onboarding.profile.upload_avatar": "プロフィール画像をアップロード",
  "onboarding.profile.upload_header": "プロフィールのヘッダー画像をアップロード",
  "password_confirmation.exceeds_maxlength": "パスワードの最大文字数を超えています",
  "password_confirmation.mismatching": "入力済みのパスワードと一致しません",
  "picture_in_picture.restore": "元に戻す",
  "poll.closed": "終了",
  "poll.refresh": "更新",
  "poll.reveal": "結果を表示",
  "poll.total_people": "{count}人",
  "poll.total_votes": "{count}票",
  "poll.vote": "投票",
  "poll.voted": "この項目に投票しました",
  "poll.votes": "{votes}票",
  "poll_button.add_poll": "アンケートを追加",
  "poll_button.remove_poll": "アンケートを削除",
  "privacy.change": "公開範囲を変更",
  "privacy.direct.long": "本文で指定した相手のみ",
  "privacy.direct.short": "非公開の返信",
  "privacy.private.long": "フォロワーのみ",
  "privacy.private.short": "フォロワー",
  "privacy.public.long": "すべての人 (Mastodon以外も含む)",
  "privacy.public.short": "公開",
  "privacy.quote.anyone": "{visibility}、引用可",
  "privacy.quote.disabled": "{visibility}、引用不可",
  "privacy.quote.limited": "{visibility}、引用は制限",
  "privacy.unlisted.additional": "「公開」とほとんど同じですが、リアルタイムフィードやハッシュタグ、探索機能、Mastodon検索などに投稿が表示されない点で「公開」と異なります。また、アカウント設定で投稿の検索や表示を許可している場合でも、この公開範囲を設定した投稿は前述の機能には表示されません。",
  "privacy.unlisted.long": "Mastodonの検索結果、トレンド、公開タイムラインに表示しない",
  "privacy.unlisted.short": "ひかえめな公開",
  "privacy_policy.last_updated": "{date}に更新",
  "privacy_policy.title": "プライバシーポリシー",
  "recommended": "おすすめ",
  "refresh": "更新",
  "regeneration_indicator.please_stand_by": "しばらくお待ちください。",
  "regeneration_indicator.preparing_your_home_feed": "ホームタイムライン準備中…",
  "relative_time.days": "{number}日前",
  "relative_time.full.days": "{number}日前",
  "relative_time.full.hours": "{number}時間前",
  "relative_time.full.just_now": "今",
  "relative_time.full.minutes": "{number}分前",
  "relative_time.full.seconds": "{number}秒前",
  "relative_time.hours": "{number}時間前",
  "relative_time.just_now": "今",
  "relative_time.minutes": "{number}分前",
  "relative_time.seconds": "{number}秒前",
  "relative_time.today": "今日",
  "remove_quote_hint.button_label": "了解",
  "reply_indicator.attachments": "{count, plural, other {#件のメディア}}",
  "reply_indicator.cancel": "キャンセル",
  "reply_indicator.poll": "アンケート",
  "report.block": "ブロック",
  "report.block_explanation": "相手の投稿が表示されなくなります。相手はあなたの投稿を見ることやフォローすることができません。相手はブロックされていることがわかります。",
  "report.categories.legal": "法令違反",
  "report.categories.other": "その他",
  "report.categories.spam": "スパム",
  "report.categories.violation": "サーバーのルールに違反",
  "report.category.subtitle": "近いものを選択してください",
  "report.close": "完了",
  "report.comment.title": "その他に私たちに伝えておくべき事はありますか？",
  "report.forward": "{target}に転送する",
  "report.forward_hint": "このアカウントは別のサーバーに所属しています。通報内容を匿名で転送しますか？",
  "report.mute": "ミュート",
  "report.mute_explanation": "相手の投稿は表示されなくなります。相手は引き続きあなたをフォローして、あなたの投稿を表示することができますが、ミュートされていることはわかりません。",
  "report.next": "次へ",
  "report.placeholder": "追加コメント",
  "report.reasons.dislike": "興味がありません",
  "report.reasons.dislike_description": "見たくない内容の場合",
  "report.reasons.legal": "違法です",
  "report.reasons.legal_description": "あなたが住んでいる国またはサーバーが存在する国の法律に違反していると思われる場合",
  "report.reasons.other": "その他",
  "report.reasons.other_description": "当てはまる選択肢がない場合",
  "report.reasons.spam": "これはスパムです",
  "report.reasons.spam_description": "悪意のあるリンクや虚偽の情報、執拗な返信など",
  "report.reasons.violation": "サーバーのルールに違反しています",
  "report.reasons.violation_description": "ルールに違反しているのを見つけた場合",
  "report.rules.subtitle": "当てはまるものをすべて選んでください:",
  "report.rules.title": "どのルールに違反していますか？",
  "report.statuses.subtitle": "当てはまるものをすべて選んでください:",
  "report.statuses.title": "この通報を裏付けるような投稿はありますか？",
  "report.submit": "通報する",
  "report.target": "{target}さんを通報する",
  "report.thanks.take_action": "次のような方法はいかがでしょうか？",
  "report.thanks.take_action_actionable": "私達が確認している間でも、あなたは@{name}さんに対して対応することが出来ます：",
  "report.thanks.title": "見えないようにしたいですか？",
  "report.thanks.title_actionable": "ご報告ありがとうございます、追って確認します。",
  "report.unfollow": "@{name}さんのフォローを解除",
  "report.unfollow_explanation": "このアカウントをフォローしています。ホームフィードに彼らの投稿を表示しないようにするには、彼らのフォローを外してください。",
  "report_notification.attached_statuses": "{count, plural, one {{count}件の投稿} other {{count}件の投稿}}が添付されました。",
  "report_notification.categories.legal": "法令違反",
  "report_notification.categories.legal_sentence": "法令違反",
  "report_notification.categories.other": "その他",
  "report_notification.categories.other_sentence": "その他",
  "report_notification.categories.spam": "スパム",
  "report_notification.categories.spam_sentence": "スパム",
  "report_notification.categories.violation": "ルール違反",
  "report_notification.categories.violation_sentence": "ルール違反",
  "report_notification.open": "通報を開く",
  "search.clear": "検索をクリア",
  "search.no_recent_searches": "検索履歴はありません",
  "search.placeholder": "検索",
  "search.quick_action.account_search": "{x}に該当するプロフィール",
  "search.quick_action.go_to_account": "プロフィール {x} を見る",
  "search.quick_action.go_to_hashtag": "ハッシュタグ {x} を見る",
  "search.quick_action.open_url": "MastodonでURLを開く",
  "search.quick_action.status_search": "{x}に該当する投稿",
  "search.search_or_paste": "検索またはURLを入力",
  "search_popout.full_text_search_disabled_message": "{domain}では利用できません。",
  "search_popout.full_text_search_logged_out_message": "ログイン時のみ利用できます。",
  "search_popout.language_code": "ISO言語コード",
  "search_popout.options": "検索オプション",
  "search_popout.quick_actions": "クイック操作",
  "search_popout.recent": "最近の検索",
  "search_popout.specific_date": "特定の日付",
  "search_popout.user": "ユーザー",
  "search_results.accounts": "ユーザー",
  "search_results.all": "すべて",
  "search_results.hashtags": "ハッシュタグ",
  "search_results.no_results": "結果なし。",
  "search_results.no_search_yet": "投稿、プロフィール、またはハッシュタグを検索してみてください。",
  "search_results.see_all": "すべて表示",
  "search_results.statuses": "投稿",
  "search_results.title": "「{q}」を検索",
  "server_banner.about_active_users": "過去30日間にこのサーバーを使用している人 (月間アクティブユーザー)",
  "server_banner.active_users": "人のアクティブユーザー",
  "server_banner.administered_by": "管理者",
  "server_banner.is_one_of_many": "{domain} は、数々の独立したMastodonサーバーのうちのひとつです。サーバーに登録してFediverseのコミュニティに加わってみませんか。",
  "server_banner.server_stats": "サーバーの情報",
  "sign_in_banner.create_account": "アカウント作成",
  "sign_in_banner.follow_anyone": "連合内の誰でもフォローして投稿を時系列で見ることができます。アルゴリズム、広告、クリックベイトはありません。",
  "sign_in_banner.mastodon_is": "Mastodonに参加して、世界で起きていることを見つけよう。",
  "sign_in_banner.sign_in": "ログイン",
  "sign_in_banner.sso_redirect": "ログインまたは登録",
  "status.admin_account": "@{name}さんのモデレーション画面を開く",
  "status.admin_domain": "{domain}のモデレーション画面を開く",
  "status.admin_status": "この投稿をモデレーション画面で開く",
  "status.block": "@{name}さんをブロック",
  "status.bookmark": "ブックマーク",
  "status.cancel_reblog_private": "ブースト解除",
  "status.cannot_quote": "この投稿は引用できません",
  "status.cannot_reblog": "この投稿はブーストできません",
  "status.context.retry": "リトライ",
  "status.continued_thread": "続きのスレッド",
  "status.copy": "投稿へのリンクをコピー",
  "status.delete": "削除",
  "status.delete.success": "投稿を削除しました",
  "status.detailed_status": "詳細な会話ビュー",
  "status.direct": "@{name}さんに非公開で投稿",
  "status.direct_indicator": "非公開の返信",
  "status.edit": "編集",
  "status.edited": "最終更新日 {date}",
  "status.edited_x_times": "{count}回編集",
  "status.embed": "埋め込みコードを取得",
  "status.favourite": "お気に入り",
  "status.filter": "この投稿をフィルターする",
  "status.history.created": "{name}さんが{date}に作成",
  "status.history.edited": "{name}さんが{date}に編集",
  "status.load_more": "もっと見る",
  "status.media.open": "クリックして開く",
  "status.media.show": "クリックして表示",
  "status.media_hidden": "非表示のメディア",
  "status.mention": "@{name}さんに投稿",
  "status.more": "もっと見る",
  "status.mute": "@{name}さんをミュート",
  "status.mute_conversation": "会話をミュート",
  "status.open": "詳細を表示",
  "status.pin": "プロフィールに固定表示",
  "status.quote": "引用",
  "status.quote.cancel": "引用をキャンセル",
  "status.quote_error.filtered": "あなたのフィルター設定によって非表示になっています",
  "status.quote_error.pending_approval": "承認待ちの投稿",
  "status.quote_noun": "引用",
  "status.quote_policy_change": "引用できるユーザーの変更",
  "status.quote_post_author": "{name} の投稿を引用",
  "status.quote_private": "非公開の投稿は引用できません",
  "status.quotes.local_other_disclaimer": "投稿者が拒否した引用は表示されません。",
  "status.read_more": "もっと見る",
  "status.reblog": "ブースト",
  "status.reblog_or_quote": "ブーストか引用",
  "status.reblogged_by": "{name}さんがブースト",
  "status.reblogs.empty": "まだ誰もブーストしていません。ブーストされるとここに表示されます。",
  "status.redraft": "削除して下書きに戻す",
  "status.remove_bookmark": "ブックマークを削除",
  "status.remove_favourite": "お気に入りから削除",
  "status.remove_quote": "削除",
  "status.replied_in_thread": "ほかのユーザーへ",
  "status.replied_to": "{name}さんへの返信",
  "status.reply": "返信",
  "status.replyAll": "全員に返信",
  "status.report": "@{name}さんを通報",
  "status.revoke_quote": "{name} さんの投稿から自分の投稿を削除",
  "status.sensitive_warning": "閲覧注意",
  "status.share": "共有",
  "status.show_less_all": "全て隠す",
  "status.show_more_all": "全て見る",
  "status.show_original": "原文を表示",
  "status.title.with_attachments": "{user}さんの投稿 {attachmentCount, plural, other {({attachmentCount}件のメディア)}}",
  "status.translate": "翻訳",
  "status.translated_from_with": "{provider}を使って{lang}から翻訳",
  "status.uncached_media_warning": "プレビューは使用できません",
  "status.unmute_conversation": "会話のミュートを解除",
  "status.unpin": "プロフィールへの固定を解除",
  "subscribed_languages.lead": "選択した言語の投稿だけがホームとリストのタイムラインに表示されます。全ての言語の投稿を受け取る場合は全てのチェックを外して下さい。",
  "subscribed_languages.save": "変更を保存",
  "subscribed_languages.target": "{target}さんの購読言語を変更します",
  "tabs_bar.home": "ホーム",
  "tabs_bar.menu": "メニュー",
  "tabs_bar.notifications": "通知",
  "tabs_bar.publish": "新しい投稿",
  "tabs_bar.search": "検索",
  "tag.add_favourite.public": "お気に入り登録(公開)",
  "tag.add_favourite.unlisted": "お気に入り登録(未収載)",
  "tag.remove_favourite.public": "お気に入り解除(公開)",
  "tag.remove_favourite.unlisted": "お気に入り解除(未収載)",
  "terms_of_service.effective_as_of": "{date}より有効",
  "terms_of_service.title": "サービス利用規約",
  "terms_of_service.upcoming_changes_on": "{date}から適用される変更",
  "time_remaining.days": "残り{number}日",
  "time_remaining.hours": "残り{number}時間",
  "time_remaining.minutes": "残り{number}分",
  "time_remaining.moments": "まもなく終了",
  "time_remaining.seconds": "残り{number}秒",
  "trends.counter_by_accounts": "過去{days, plural, one {{days}日} other {{days}日}}に{count, plural, one {{counter}人} other {{counter} 人}}",
  "trends.trending_now": "トレンドタグ",
  "ui.beforeunload": "Mastodonから離れると送信前の投稿は失われます。",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "ドラッグ＆ドロップでアップロード",
  "upload_button.label": "メディアを追加 (複数の画像または1つの動画か音声ファイル)",
  "upload_error.limit": "アップロードできる上限を超えています。",
  "upload_error.poll": "アンケートではファイルをアップロードできません。",
  "upload_error.quote": "引用ではファイルをアップロードできません。",
  "upload_form.drag_and_drop.instructions": "メディア添付ファイルを選択するには、スペースキーまたはエンターキーを押してください。ドラッグ中は、矢印キーを使ってメディア添付ファイルを任意の方向に移動できます。再度スペースキーまたはエンターキーを押すと新しい位置にメディア添付ファイルをドロップできます。キャンセルするにはエスケープキーを押してください。",
  "upload_form.drag_and_drop.on_drag_cancel": "ドラッグがキャンセルされました。メディア添付ファイル {item} がドロップされました。",
  "upload_form.drag_and_drop.on_drag_end": "メディア添付ファイル {item} がドロップされました。",
  "upload_form.drag_and_drop.on_drag_over": "メディア添付ファイル {item} が移動されました。",
  "upload_form.drag_and_drop.on_drag_start": "メディア添付ファイル {item} を選択しました。",
  "upload_form.edit": "編集",
  "upload_progress.label": "アップロード中...",
  "upload_progress.processing": "処理中…",
  "username.taken": "このユーザー名はすでに使用されています。ほかのユーザー名を入力してください",
  "video.close": "動画を閉じる",
  "video.download": "ダウンロード",
  "video.exit_fullscreen": "全画面を終了する",
  "video.expand": "動画を拡大する",
  "video.fullscreen": "全画面",
  "video.hide": "動画を閉じる",
  "video.mute": "ミュート",
  "video.pause": "一時停止",
  "video.play": "再生",
  "video.skip_backward": "後方にスキップ",
  "video.skip_forward": "前方にスキップ",
  "video.unmute": "ミュート解除",
  "video.volume_down": "音量を下げる",
  "video.volume_up": "音量を上げる",
  "visibility_modal.button_title": "公開範囲の設定",
  "visibility_modal.header": "公開範囲と引用",
  "visibility_modal.helper.direct_quoting": "Mastodon で作成された非公開の返信は他人から引用できません。",
  "visibility_modal.helper.private_quoting": "Mastodon で作成されたフォロワーのみの投稿は他人から引用できません。",
  "visibility_modal.helper.unlisted_quoting": "誰かがあなたを引用すると、その投稿もトレンドから非表示になります。",
  "visibility_modal.instructions": "この投稿の公開・引用範囲を設定します。また、<link>「デフォルトの投稿設定」</link>から今後の投稿の範囲を設定可能です。",
  "visibility_modal.privacy_label": "公開範囲",
  "visibility_modal.quote_followers": "フォロワーのみ",
  "visibility_modal.quote_label": "引用できるユーザー",
  "visibility_modal.quote_nobody": "自分のみ",
  "visibility_modal.quote_public": "誰でも",
  "visibility_modal.save": "保存"
}
